export const listCodeRepositories = `
   query listCodeRepositories($filter: CodeRepositoriesFilterInput, $limit: Int, $nextToken: String) {
       listCodeRepositories(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              name
              provider
              description
              defaultBranch
           }
           nextToken
       }
   }
`;
